<div class="top-post-container">
  <div *ngIf="showFallbackView">
    <top-post-placeholder></top-post-placeholder>
  </div>
  <div class="row" *ngIf="!showFallbackView">
    <div class="col-md-12 d-flex flex-column flex-auto top-5-posts-body-table">
      <div class="row align-items-center top-5-posts-body-table-header">
        <div class="col-md-7 col-sm-7 top-5-posts-body-table-col"></div>
        <div class="col-md-1 col-sm-1 top-5-posts-body-table-col"></div>
        <div class="col-md-2 col-sm-2 top-5-posts-body-table-col">
          <span class="d-flex justify-content-end text-capitalize pie-chart-reach-title">{{'common.measure.kpi_name.reach' | translate}}</span>
        </div>
        <div class="col-md-2 col-sm-2 top-5-posts-body-table-col">
          <span class="d-flex justify-content-end text-capitalize pie-chart-impact-title">{{'common.measure.kpi_name.impact' | translate}}</span>
        </div>
      </div>
      <div class="row align-items-center top-5-posts-body-table-row" [ngClass]="{'current-post': isCurrentPost(post)}" (click)="goToPost(post.url)" *ngFor="let post of topPosts; let i = index">
        <div class="col-md-7 col-sm-7 top-5-posts-body-table-col" title="{{post.title}}">
          <div class="d-flex flex-row justify-content-start post-title">
            <span class="d-flex justify-content-end post-index" *ngIf="!isCurrentPost(post)">{{i + 1}}.</span>
            <span class="d-flex justify-content-end post-index" *ngIf="isCurrentPost(post)">{{currentPost.postRank}}.</span>
            <span class="post-content">{{post.title}}</span>
          </div>
        </div>
        <div class="col-md-1 col-sm-1 top-5-posts-body-table-col justify-content-center align-items-center">
          <span *ngIf="post.platform" class="platform-icon">
            <img [src]="getPlatformIcon(post.platform.id)" placement="top">
          </span>
        </div>
        <div class="col-md-2 col-sm-2 top-5-posts-body-table-col">
          <span class="d-flex flex-row flex-auto justify-content-end pie-chart-reach">{{post.reach | thousandNumberSuffix: 1}}</span>
        </div>
        <div class="col-md-2 col-sm-2 top-5-posts-body-table-col">
          <span class="d-flex flex-row flex-auto justify-content-end pie-chart-impact">{{post.impact | percent}}</span>
        </div>
      </div>
    </div>
  </div>
</div>




// WEBPACK FOOTER //
// ./src/app/main/post-overview/same-influencer-top-five-posts/same-influencer-top-five-posts.component.html